import { Guid, SerializableObject } from '../../common-react/core';

import { Label } from './label.do';

export class ShipmentFee extends SerializableObject {
  public id: Guid;
  public currency: string;
  public description: string;
  public grossAmount: number;
  public netAmount: number;
  public vatAmount: number;
  public isPayble: boolean;
  public isPaid: boolean;
  public labels: Label[];
}
